// Other
import { computed, Ref } from 'vue';
import { $error } from '@/utils/app-utils';
import AuthorizationProvider from '@/core/Authorization/AuthorizationProvider';
import Operations from '@/core/Authorization/Operations';
import NumericCounterService from '@/core/Services/NumericCounterService';
import INumericCounter from '@/core/Models/INumericCounter';

const api = {
    async createAsync(numericCounter: INumericCounter): Promise<INumericCounter | undefined> {
        try {
            return await NumericCounterService.createAsync(
                {
                    key: numericCounter.key,
                    name: numericCounter.name,
                    units: numericCounter.units,
                },
                'default',
            );
        } catch (error) {
            $error(error);
        }
    },

    async patchAsync(numericCounter: INumericCounter): Promise<void> {
        try {
            await NumericCounterService.patchAsync(numericCounter.id, {
                key: numericCounter.key,
                name: numericCounter.name,
            });
        } catch (error) {
            $error(error);
        }
    },
};

export function useNumericCounterApi() {
    return api;
}

export function useNumericCounterForm(numericCounter: Ref<INumericCounter>) {
    const editable = computed(() => true);
    const disabled = computed(() => false);

    return {
        editable,
        disabled,

        patchAsync: () => api.patchAsync(numericCounter.value),
        createAsync: () => api.createAsync(numericCounter.value),
    };
}

export function useNumericCounterPermissions(numericCounter: Ref<INumericCounter>) {
    const canRead = AuthorizationProvider.authorize(numericCounter.value, Operations.NumericCounters.Read);
    const canCreate = AuthorizationProvider.authorize(numericCounter.value, Operations.NumericCounters.Create);
    const canDelete = AuthorizationProvider.authorize(numericCounter.value, Operations.NumericCounters.Delete);
    const canUpdatePublicFields = AuthorizationProvider.authorize(
        numericCounter.value,
        Operations.NumericCounters.UpdatePublicFields,
    );
    const canUpdatePrivateFields = AuthorizationProvider.authorize(
        numericCounter.value,
        Operations.NumericCounters.UpdatePrivateFields,
    );

    return {
        canRead,
        canCreate,
        canDelete,
        canUpdatePublicFields,
        canUpdatePrivateFields,
    };
}
